import { REDUCER } from '../reducers/reducersConst';
import { GROUPS } from '../const';

let initialState = {
  startDate: null,
  dueDate: null,
  selectedGroup: Object.assign({}, GROUPS.EVERYONE),
  activities: null,
  fetchingBooksActivities: false,
  checkedActivities: [],
  responseFile: null,
  descriptionTask: '',
  allowFile: false,
  allowUserCommentResponse: false,
  titleTask: '',
  evaluatedStudent: null,
  uploadFileTaskStatus: {
    percentCompleted: 0,
    isUploading: false,
    cancelUpload: null
  }
};

export let assignmentsDrawerActions = (state = initialState, action) => {
  switch (action.type) {
    case REDUCER.ASSIGNMENT_DRAWER.SET_SELECTED_GROUP:
      return {
        ...state,
        selectedGroup: action.selectedGroup
      };
    case REDUCER.ASSIGNMENT_DRAWER.SET_DUE_DATE:
      return {
        ...state,
        dueDate: action.dueDate
      };
    case REDUCER.ASSIGNMENT_DRAWER.SET_START_DATE:
      return {
        ...state,
        startDate: action.startDate
      };
    case REDUCER.ASSIGNMENT_DRAWER.SET_DESCRIPTION_TASK:
      return {
        ...state,
        descriptionTask: action.descriptionTask
      };
    case REDUCER.ASSIGNMENT_DRAWER.SET_TITLE_TASK:
      return {
        ...state,
        titleTask: action.titleTask
      };
    case REDUCER.ASSIGNMENT_DRAWER.SET_ALLOW_FILE:
      return {
        ...state,
        allowFile: action.allowFile
      };
    case REDUCER.ASSIGNMENT_DRAWER.SET_ALLOW_USER_COMMENT_RESPONSE:
      return {
        ...state,
        allowUserCommentResponse: action.allowUserCommentResponse
      };
    case REDUCER.ASSIGNMENT_DRAWER.SET_ACTIVITIES:
      return {
        ...state,
        activities: action.activities
      };
    case REDUCER.ASSIGNMENT_DRAWER.SET_FETCHING_BOOKS_ACTIVITIES:
      return {
        ...state,
        fetchingBooksActivities: action.fetching
      };
    case REDUCER.ASSIGNMENT_DRAWER.ON_CHECKED_ACTIVITIES_CHANGE:
      return {
        ...state,
        checkedActivities: action.checkedActivities
      };
    case REDUCER.ASSIGNMENT_DRAWER.SET_EVALUATED_STUDENT:
      return {
        ...state,
        evaluatedStudent: action.evaluatedStudent
      };
    case REDUCER.ASSIGNMENT_DRAWER.SET_RESPONSE_FILE:
      return {
        ...state,
        responseFile: action.file
      };
    case REDUCER.ASSIGNMENT_DRAWER.SET_UPLOAD_DRAWER_FILE_STATUS:
      return {
        ...state,
        uploadFileTaskStatus: action.uploadFileTaskStatus
      };
    default:
      return state;
  }
};
